(() => {
  const source = document.currentScript?.dataset.chatSrc;
  if (!source) return;
  let loaded = false;
  function loadChat() {
    if (loaded) return;
    loaded = true;
    document.removeEventListener('pointerdown', loadChat);
    document.removeEventListener('keydown', loadChat);
    const script = document.createElement('script');
    script.src = source;
    script.async = true;
    document.body.append(script);
  }
  document.addEventListener('pointerdown', loadChat, { once: true, passive: true });
  document.addEventListener('keydown', loadChat, { once: true });
  function schedule() {
    if ('requestIdleCallback' in window) window.requestIdleCallback(loadChat, { timeout: 2000 });
    else window.setTimeout(loadChat, 1200);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
})();
